/**
 * Created by piotr.pozniak@thebeaverhead.com on 22/09/2022.
 */
import { PLANS } from "../../../../../consts";
import { useCurrentOrganizationStore } from "../../../../../hooks/redux/currentOrganization";
import { hasSubscription } from "../../../helpers/organization";

export function useFailedPayment2Alert() {
  const { currentOrganization } = useCurrentOrganizationStore();

  if (!currentOrganization.model) {
    return null;
  }

  const model = currentOrganization.model;
  const subscription = hasSubscription(currentOrganization);
  const isOnFreePlan = !subscription || subscription.code === PLANS.free;

  if (
    !Number.parseInt(model.sent_timestamp_renewal_failed_period_2) ||
    isOnFreePlan
  ) {
    return null;
  }

  return {
    id: "failedPayment2",
    variant: "critical",
    icon: "AlertCircle",
    title: "Payment failed again",
    body: "Update billing within 3 days or your account reverts to the free plan.",
    action: { label: "Update billing", to: "/billing" },
  };
}

export default useFailedPayment2Alert;
